import { useState } from 'react';
import { Modal, TextInput, Button, Group, Textarea } from '@mantine/core';
import { updateCustomer } from "../../services/customer";

const CustomerEdit = ({ customer, setEditModalOpen, refreshCustomer }) => {
    const [loading, setLoading] = useState(false);
    const [name, setName] = useState(customer.name || "");
    const [email, setEmail] = useState(customer.email || '');
    const [phone, setPhone] = useState(customer.phone || '');
    const [address, setAddress] = useState(customer.address || '');
    const [notes, setNotes] = useState(customer.notes || '');

    const handleUpdate = async () => {
        setLoading(true);
        try {
            await updateCustomer({
                customerId: customer._id,
                name,
                email,
                phone,
                address,
                notes
            });
            refreshCustomer();
            setEditModalOpen(false);
        } catch (error) {
            console.error('Failed to update customer:', error);
        }
        setLoading(false);
    };

    return (
        <Modal
            opened={true}
            onClose={() => setEditModalOpen(false)}
            title="Editar Cliente"
            size="lg"
            closeOnClickOutside={false}
        >
            <form onSubmit={(e) => {
                e.preventDefault();
                handleUpdate();
            }}>
                <TextInput
                    label="Nombre"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                />

                <TextInput
                    label="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <TextInput
                    label="Teléfono"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                />
                <TextInput
                    label="Dirección"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                />

                <Textarea
                    label="Notas"
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                    placeholder="Notas adicionales"
                    disabled={loading}
                    mb="md"
                />

                <Group justify="end" mt="md">
                    <Button type="button" variant='transparent' onClick={() => setEditModalOpen(false)}>Cancelar</Button>
                    <Button type="submit" color="blue" loading={loading}>Actualizar</Button>
                </Group>
            </form>
        </Modal>
    );
};

export default CustomerEdit;
